import { useState } from "react";
import { validatePassword } from "../../Utils/Constants/Constants";
import InputBox from "../InputBox/InputBox";
import Button from "../Button/Button";

const ChangePassword = (props) => {
  const [formState, setFormState] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    props.updatePassword({
      email: props.email,
      currentPassword: formState.currentPassword,
      newPassword: formState.newPassword
    });
    props.setActive(null);
  };

  return (
    <div data-cy="change-password-form">
      <InputBox
        name="currentPassword"
        type="password"
        label="Enter Current Password"
        value={formState.currentPassword}
        onChange={handleInputChange}
        labelFontColor="font-color-tertiaryColor"
        fontColor="font-color-tertiaryColor"
        removeResponsive={true}
        data-cy="current-password-input"
      />
      <InputBox
        name="newPassword"
        type="password"
        label="Enter New Password"
        value={formState.newPassword}
        onChange={handleInputChange}
        labelFontColor="font-color-tertiaryColor"
        fontColor="font-color-tertiaryColor"
        removeResponsive={true}
        validation={(value) => validatePassword(value)}
        data-cy="new-password-input"
      />
      <InputBox
        name="confirmPassword"
        type="password"
        label="Confirm New Password"
        value={formState.confirmPassword}
        onChange={handleInputChange}
        labelFontColor="font-color-tertiaryColor"
        fontColor="font-color-tertiaryColor"
        removeResponsive={true}
        validation={(value) =>
          value !== formState.newPassword
            ? { status: false, message: "Passwords do not match" }
            : { status: true, message: "" }
        }
        data-cy="confirm-password-input"
      />
      <Button
        text="Update Password"
        disabled={
          !(
            formState.currentPassword.length > 0 &&
            validatePassword(formState.newPassword).status &&
            formState.newPassword === formState.confirmPassword
          )
        }
        onClick={handleSubmit}
        data-cy="update-password-button"
      />
    </div>
  );
};
export default ChangePassword;
